import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, memo } from "react";
import InputAdornment from "@material-ui/core/InputAdornment";
import { Rifm } from "rifm";
import { useNumberFormatter } from "../formatters/number";
import { makeStyles } from "@material-ui/core/styles";
import { DployTextField } from "../DployTextField";
import { extractNumberFormat } from "../formatters/extractNumberFormat";
const useStyles = makeStyles({
    input: {
        textAlign: ({ textAlign }) => typeof textAlign === "string"
            ? textAlign
            : "right"
    }
}, { name: "DployIntlNumberField" });
export const IntlNumberField = memo((props) => {
    const { fieldName: fieldNameNullable, prefix: propPrefix, suffix: propSuffix, format: intlFormat, style, maximumSignificantDigits, minimumSignificantDigits, maximumFractionDigits, minimumFractionDigits, minimumIntegerDigits, useGrouping, localeMatcher, currency, currencyDisplay, value: numberValue, onChange: onNumberChange, nativeOnChange, onBlur: onNumberBlur, onFocus: onNumberFocus, emptyEqualsZero, formatString, percentValueAsFraction, textAlign, allowNegative, ...rest } = props;
    const fieldName = fieldNameNullable ?? { name: "unknown" };
    const fromFormatString = useMemo(() => extractNumberFormat({}, formatString), [formatString]);
    const { value, onChange, format, onBlur, onFocus, refuse, formatPrefix, formatSuffix } = useNumberFormatter(fieldName, { ...props, ...fromFormatString }, numberValue, emptyEqualsZero, onNumberChange, onNumberBlur, onNumberFocus, undefined, undefined, percentValueAsFraction, allowNegative);
    const classes = useStyles(props);
    var suffix = propSuffix || formatSuffix;
    var prefix = propPrefix || formatPrefix;
    if (suffix === prefix) {
        suffix = undefined;
    }
    return (_jsx(Rifm, { refuse: refuse, value: value, onChange: onChange, format: format, children: rifmProps => (_jsx(DployTextField, { ...rest, ...rifmProps, style: rest.cssStyle, fieldName: fieldName, type: "tel", onBlur: onBlur, onFocus: onFocus, InputProps: {
                classes: classes,
                endAdornment: suffix && (_jsx(InputAdornment, { position: "end", disableTypography: props.disabled, children: suffix })),
                startAdornment: prefix && (_jsx(InputAdornment, { position: "start", disableTypography: props.disabled, children: prefix }))
            } })) }));
});
//# sourceMappingURL=IntlNumberField.js.map